/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import Spacer from '@atoms/Spacer';
// import OpportunitySeo from '@molecules/SEO/OpportunitySeo';
import DetailsTemplate from '@templates/OpportunityDetails';
import HeaderWithSidebar from '@app/components/templates/HeaderWithSidebar';
import HeaderTemplate from '@app/components/organisms/opportunities/OpportunityHeader';

const OpportunityMainTemplate = ({ opportunity, children, viewApplication, opportunityMemberRole, refetch }) => (
    <HeaderWithSidebar contentPadding={0}>
        <DetailsTemplate
            header={
                <HeaderTemplate
                    opportunity={opportunity}
                    viewApplication={viewApplication}
                    opportunityMemberRole={opportunityMemberRole}
                    refetch={refetch}
                />
            }
        >
            {children}
        </DetailsTemplate>
        <Spacer height="4rem" />
    </HeaderWithSidebar>
);

OpportunityMainTemplate.propTypes = {
    opportunity: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    viewApplication: PropTypes.bool,
    opportunityMemberRole: PropTypes.string,
    refetch: PropTypes.func.isRequired
};

OpportunityMainTemplate.defaultProps = {
    opportunityMemberRole: '',
    viewApplication: false,
};

export default OpportunityMainTemplate;


